import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "fw-medium text-dark" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "text-muted fs-13"
}
const _hoisted_14 = { class: "d-flex align-items-center gap-1" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Partners",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search partners...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
          ], 32),
          _createVNode(_component_RouterLink, {
            to: "/partners/create",
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                _createElementVNode("span", null, "Add New Partner")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Partner ID"),
                  _createElementVNode("th", { scope: "col" }, "Logo"),
                  _createElementVNode("th", { scope: "col" }, "Name"),
                  _createElementVNode("th", { scope: "col" }, "MoU Link"),
                  _createElementVNode("th", { scope: "col" }, "Status"),
                  _createElementVNode("th", { scope: "col" }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[4] || (_cache[4] = [
                      _createElementVNode("td", {
                        colspan: "5",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.filteredPartners.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[5] || (_cache[5] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "text-center py-4"
                        }, "No partners found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredPartners, (p) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: p.id
                        }, [
                          _createElementVNode("td", null, "#" + _toDisplayString(p.id), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("img", {
                              src: _ctx.getLogoUrl(p.logo),
                              alt: "logo",
                              class: "rounded-3 border",
                              style: {"max-height":"40px","max-width":"120px","object-fit":"contain","padding":"2px","background-color":"#fafafa"}
                            }, null, 8, _hoisted_10)
                          ]),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(p.name), 1),
                          _createElementVNode("td", null, [
                            (p.mou_link)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: p.mou_link,
                                  target: "_blank",
                                  class: "text-primary text-decoration-none hover-text-primary fs-13"
                                }, _cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "ri-external-link-line me-1" }, null, -1),
                                  _createTextVNode("View MoU ")
                                ]), 8, _hoisted_12))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge p-2 fs-12 fw-normal", p.is_active ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                            }, _toDisplayString(p.is_active ? 'Active' : 'Inactive'), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_RouterLink, {
                                to: `/partners/${p.id}/edit`,
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deletePartner(p.id)),
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                              ]), 8, _hoisted_15)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}